import { render, staticRenderFns } from "./ArticlesSubSections.vue?vue&type=template&id=39ac10d1&scoped=true&"
import script from "./ArticlesSubSections.vue?vue&type=script&lang=js&"
export * from "./ArticlesSubSections.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesSubSections.vue?vue&type=style&index=0&id=39ac10d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ac10d1",
  null
  
)

export default component.exports